import React, { FunctionComponent } from "react";

interface DividerProps {
  style: "solid" | "dotted";
  className?: string;
  width?: "auto" | `${number}%` | `${number}px`;
}

const Divider: FunctionComponent<DividerProps> = ({
  style,
  className,
  width = "100%",
}) => {
  const dividerStyle = {
    borderTop: style === "solid" ? "1px solid #e6e6e6" : "1px dotted #e6e6e6",
    width: width,
  };

  return (
    <div className={className ? className : ""} style={dividerStyle}></div>
  );
};

export default Divider;
